import { Box } from '@mui/system';
import { useTranslation } from 'react-i18next';
import { Route,Routes } from 'react-router-dom';
import { GenericTitleHeader } from '../component/common/GenericTitleHeader';
import MissingEquipmetTable from '../component/missingEquipments/MissingEqupmentTable';
import SectionHeader from "../../../util/component/SectionHeader";
import React from "react";
const MissingEquipmentsPage = () => {
    const { t } = useTranslation(["operation"]);
    return (
        <div>
            <SectionHeader
                title={t("missingEquipment.firstTitle") + " " + t("missingEquipment.secondTitle")}
            />
            <Routes><Route path="/"  element={<MissingEquipmetTable/>}/></Routes></div>
           
    );
}

export default MissingEquipmentsPage;